import { React, useState, useEffect, useContext } from "react";
import "./SecondVendor.css";
import { Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Pagination } from "swiper/modules";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { faCartShopping } from "@fortawesome/free-solid-svg-icons";
import Veggies_Section_Card from "../../Common-Component/Veggies_Section_Card/Veggies_Section_Card";
import Product_Card from "../../Common-Component/Product_Card/Product_Card";
import { Context } from "../../../utils/context";

import { Products } from "../../../utils/apis/Product/Product";
import { useOutlet } from "react-router-dom";

import SupermarketModal from "../../Common_modal/Supermarket-modal/SupermarketModal";
import Product_Info_Card from "../../Common-Component/product_info_card/Product_Info_Card";
import Common_Heading_Holder from "../../Common-Component/common_heading_holder/Common_Heading_Holder";

const SecondVendor = ({ heading, product }) => {
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [activeHearts, setActiveHearts] = useState([]);
  const handleMainSliderClick = (direction) => {
    if (swiperInstance) {
      if (direction === "prev") {
        swiperInstance.slidePrev();
      } else if (direction === "next") {
        swiperInstance.slideNext();
      }
    }
  };

  const { currentLocation } = useContext(Context);

  

  const [products, setProduct] = useState([]);
  const getProducts = async () => {
     const city =
      currentLocation?.formatted_address ||
      currentLocation?.city ||
      currentLocation?.formatted_address ||
      currentLocation?.address_components?.[0]?.long_name ||
      "";
    const res = await Products(product?.category_id, "", "","","","",city);
    if (res?.success) {
      setProduct(res?.data?.data);
    }
  };

  useEffect(() => {
    getProducts();
  }, [product,currentLocation]);

  const handleProductClick = (productId) => {
    localStorage.setItem("product_id", productId);
    window.location.reload();
  };

  return (
    <>
      <section className="Frequently-Bought">
        <Container>
          {/* <h1 className="title">{heading}</h1> */}

          <Common_Heading_Holder headingText={"You may also like"} product={product} />

          <div className="main_swiper_div">
            <Swiper
              spaceBetween={15}
              pagination={{
                dynamicBullets: true,
                clickable: true,
              }}
              modules={[Pagination]}
              autoplay={{ delay: 300 }}
              className="common_swiper"
              breakpoints={{
                0: {
                  slidesPerView: 1.5,
                  spaceBetween: 5,
                },
                380: {
                  slidesPerView: 1.5,
                  spaceBetween: 5,
                },
                480: {
                  slidesPerView: 2,
                },
                768: {
                  slidesPerView: 3,
                },
                768: {
                  slidesPerView: 3,
                },
                992: {
                  slidesPerView: 3,
                },
                1200: {
                  slidesPerView: 3,
                },
                1400: {
                  slidesPerView: 3,
                },
              }}
            >
              {products?.map((product) => {
                return (
                  <SwiperSlide>
                    <Product_Info_Card product={product} showQty />
                  </SwiperSlide>
                );
              })}
            </Swiper>
            
          </div>

          {/* <Swiper
            pagination={{
              dynamicBullets: true,
              clickable: true,
            }}
            modules={[Pagination, Navigation]}
            breakpoints={{
              0: {
                slidesPerView: 2,
                spaceBetween: 5,
              },
              486: {
                slidesPerView: 2,
                spaceBetween: 5,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 10,
              },
              992: {
                slidesPerView: 4,
                spaceBetween: 10,
              },
              1200: {
                slidesPerView: 5,
                spaceBetween: 10,
              },
              1400: {
                slidesPerView: 5,
                spaceBetween: 10,
              },
              1900: {
                slidesPerView: 5,
                spaceBetween: 10,
              },
            }}
            className="mySwiper"
            onSwiper={(swiper) => setSwiperInstance(swiper)}
          >
            {products?.map((product, index) => (
              <SwiperSlide key={index}>
                <div onClick={() => handleProductClick(product?.id)}>
                  <Product_Card
                    image={IMG_URL + product?.image1}
                    product_id={product?.id}
                    text={product?.name}
                    subText={product?.short_description}
                    price={product?.variants[0]?.s_price}
                    variant_id={product?.variants[0]?.id}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper> */}
          {/* <SupermarketModal
            show={addCartModal}
            onHide={() => setAddCartModal(false)}
          />
          <div class="silder-btn">
            <div
              className="back-btn"
              onClick={() => handleMainSliderClick("prev")}
            ></div>
            <div
              className="next-btn"
              onClick={() => handleMainSliderClick("next")}
            ></div>
          </div> */}
        </Container>
      </section>
    </>
  );
};

export default SecondVendor;
